<template>
  <list-input-text
    type="text"
    placeholder="次に読む本を選ぶ"
    :get="get"
    :set="set"
  />
</template>

<script>
import ListInputText from '@/lib/List/Input/Text'

export default {
  components: {
    ListInputText
  },

  computed: {
    get () {
      return () => {
        return this.$store.state.habit.alternateAction
      }
    },

    set () {
      return (value) => {
        this.$store.commit('habit/setAlternateAction', value)
      }
    }
  }
}
</script>
